import { NgModule }      from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule }    from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
//import { HttpModule, XSRFStrategy, CookieXSRFStrategy } from '@angular/common/http';
//import { CookieXSRFStrategy } from '@angular/common/http';
//import { HttpClientXsrfModule } from '@angular/common/http';
//import { HttpXsrfTokenExtractor } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
//import { CommonModule }   from '@angular/common';
import { MaterialAppModule } from './ngmaterial.module';

// used to create fake backend
import { fakeBackendProvider } from './_helpers/index';

import { AppComponent }  from './app.component';
import { routing }  from './app.routing';

import { AlertComponent } from './_directives/index';
import { AuthGuard, RoleGuard, CanDeactivateGuard } from './_guards/index';
import { JwtInterceptor } from './_helpers/index';
import { AlertService, AuthenticationService, UserService, SDGComponentService, ResultService, SummaryService, AddQuestionService, FeedbackService, TeamMembersService, ResourceService } from './_services/index';
import { StatusService } from './_services/status.service'
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { IntroductionComponent } from './introduction/introduction.component';
import { IntroHomeComponent } from './introduction/intro-home/intro-home.component';
import { OverviewComponent } from './introduction/overview/overview.component';
import { SummaryComponent } from './introduction/summary/summary.component';
import { HeaderComponent } from './header/header.component';
import { FourElementComponent } from './introduction/four-element/four-element.component';
import { AdminComponent } from './admin/admin.component';
import { SdgComponent } from './sdg/sdg.component';
import { SdgHomeComponent } from './sdg/sdg-home/sdg-home.component';
import { CapacityResourceComponent } from './sdg/capacity-resource/capacity-resource.component';
import { CapacityQuestComponent } from './sdg/capacity-quest/capacity-quest.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ConfirmPasswordComponent } from './confirm-password/confirm-password.component';
import { StatusComponent } from './sdg/status/status.component';
import { FinanceComponent } from './sdg/finance/finance.component';
import { SdgHeaderComponent } from './sdg/sdg-header/sdg-header.component';
import { GenderComponent } from './sdg/gender/gender.component';
import { PolicyComponent } from './sdg/policy/policy.component';
import { ResilienceComponent } from './sdg/resilience/resilience.component';
import { CapacityDataComponent } from './sdg/capacity-data/capacity-data.component';
import { CapacityReportComponent } from './sdg/capacity-report/capacity-report.component';
import { FinanceReportComponent } from './sdg/finance-report/finance-report.component';
import { FinanceQuestComponent } from './sdg/finance-quest/finance-quest.component';
import { FinanceDataComponent } from './sdg/finance-data/finance-data.component';
import { PolicyDataComponent } from './sdg/policy-data/policy-data.component';
import { PolicyQuestComponent } from './sdg/policy-quest/policy-quest.component';
import { PolicyReportComponent } from './sdg/policy-report/policy-report.component';
import { GenderDataComponent } from './sdg/gender-data/gender-data.component';
import { GenderQuestComponent } from './sdg/gender-quest/gender-quest.component';
import { GenderReportComponent } from './sdg/gender-report/gender-report.component';
import { ResilienceDataComponent } from './sdg/resilience-data/resilience-data.component';
import { ResilienceQuestComponent } from './sdg/resilience-quest/resilience-quest.component';
import { ResilienceReportComponent } from './sdg/resilience-report/resilience-report.component';
import { TransparencyComponent } from './sdg/transparency/transparency.component';
import { TransparencyQuestComponent } from './sdg/transparency-quest/transparency-quest.component';
import { TransparencyDataComponent } from './sdg/transparency-data/transparency-data.component';
import { TransparencyReportComponent } from './sdg/transparency-report/transparency-report.component';
import { ResourceQuestComponent } from './sdg/resource-quest/resource-quest.component';
import { StatusReportComponent } from './sdg/status-report/status-report.component';
import { StatusDataComponent } from './sdg/status-data/status-data.component';
import { StatusQuestComponent } from './sdg/status-quest/status-quest.component';
import { ViewSummaryComponent } from './view-summary/view-summary.component';
import { AddQuestionComponent } from './sdg/add-question/add-question.component';
import { LangChangeComponent } from './lang-change/lang-change.component';
import { ProfileComponent } from './profile/profile.component';
import { UserApprovalComponent } from './user-approval/user-approval.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { ManageTeamComponent } from './manage-team/manage-team.component';
//import { IntegrityQuestComponent } from './sdg/integrity-quest/integrity-quest.component';
//import { IntegrityDataComponent } from './sdg/integrity-data/integrity-data.component';
//import { IntegrityReportComponent } from './sdg/integrity-report/integrity-report.component';
//import { IntegrityComponent } from './sdg/integrity/integrity.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SaveDiscardDialogComponent } from './sdg/save-discard-dialog/save-discard-dialog.component';
import { LandingComponent } from './landing/landing.component';
import { EcourseComponent } from './introduction/ecourse/ecourse.component';
import { SafePipe } from './_pipes/safe.pipe';
import { OnlineCourseComponent } from './online-course/online-course.component';
import { OnlineCourseHeaderComponent } from './online-course-header/online-course-header.component';
import { DirectionDirective } from './_directives/direction.directive';
import { LanguageDirectionService } from './_services/language-direction.service';
@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
//        HttpModule,
        HttpClientModule,
        routing,
        BrowserAnimationsModule,
        MaterialAppModule,
        ReactiveFormsModule,
        FormsModule,
        MatDialogModule
//        HttpClientXsrfModule.withOptions({
//          cookieName: 'csrftoken',
//          headerName: 'X-CSRFToken',
//        })
    ],
    declarations: [
        AppComponent,
        AlertComponent,
        HomeComponent,
        LoginComponent,
        RegisterComponent,
        IntroductionComponent,
        OverviewComponent,
        SummaryComponent,
        HeaderComponent,
        IntroHomeComponent,
        FourElementComponent,
        SdgHomeComponent,
        AdminComponent,
        CapacityResourceComponent,
        SdgComponent,
        CapacityQuestComponent,
        ForgotPasswordComponent,
        ConfirmPasswordComponent,
        StatusComponent,
        FinanceComponent,
        SdgHeaderComponent,
        GenderComponent,
        PolicyComponent,
        ResilienceComponent,
        CapacityDataComponent,
        CapacityReportComponent,
        FinanceReportComponent,
        FinanceQuestComponent,
        FinanceDataComponent,
        PolicyDataComponent,
        PolicyQuestComponent,
        PolicyReportComponent,
        GenderDataComponent,
        GenderQuestComponent,
        GenderReportComponent,
        ResilienceDataComponent,
        ResilienceQuestComponent,
        ResilienceReportComponent,
        TransparencyComponent,
        TransparencyQuestComponent,
        TransparencyDataComponent,
        TransparencyReportComponent,
        ResourceQuestComponent,
        StatusReportComponent,
        StatusDataComponent,
        StatusQuestComponent,
        ViewSummaryComponent,
        AddQuestionComponent,
        LangChangeComponent,
        ProfileComponent,
        UserApprovalComponent,
        FeedbackComponent,
        ManageTeamComponent,
        SaveDiscardDialogComponent,
        LandingComponent,
        EcourseComponent,
        SafePipe,
        OnlineCourseComponent,
        OnlineCourseHeaderComponent,
        DirectionDirective,
//        IntegrityQuestComponent,
//        IntegrityDataComponent,
//        IntegrityReportComponent,
//        IntegrityComponent
    ],
    entryComponents: [
    SaveDiscardDialogComponent
  ],
    providers: [
        AuthGuard,
        RoleGuard,
        AlertService,
        AuthenticationService,
        UserService,
        SDGComponentService,
        ResultService,
        SummaryService,
        AddQuestionService,
        StatusService,
        FeedbackService,
        TeamMembersService,
        ResourceService,
        LanguageDirectionService,
//        {
//            provide: XSRFStrategy,
//            useValue: new CookieXSRFStrategy('csrftoken', 'X-CSRFToken')
//        }
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true
        },
        // provider used to create fake backend
        fakeBackendProvider,
        CanDeactivateGuard
    ],
    bootstrap: [AppComponent]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts